import Quill, { DeltaStatic, KeyboardStatic, RangeStatic, StringMap, SelectionChangeHandler, TextChangeHandler } from 'quill';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export {
    Quill,
    DeltaStatic,
    KeyboardStatic,
    RangeStatic,
    StringMap,
    SelectionChangeHandler,
    TextChangeHandler
}